import React from 'react';

const SponsorsMentors = () => {
    return (
        <div className="document">
            <h1>🤝 Sponsors & Mentors</h1>
            <p>
                The Forest Park Middle School NoCode Hackathon Demo is made possible through the STEM program, and through the support of Dr. RAS Geddes and the Geddes Neural Network (GNN). Here's a bit about each sponsor and how they're contributing to this event.
            </p>

            <h2>NYX NoCode LLC</h2>
            <p>
                <strong>Role:</strong> NYX NoCode is the main platform you'll use for the hackathon, designed by Karen Kilroy, who's passionate about helping everyone create through technology. Karen Kilroy programs computers and writes technology books.
            </p>
            <h2>Dr. RAS Geddes and the Geddes Neural Network (GNN)</h2>
           <p><strong>Role:</strong> Leadership and tutelage for hackathon participants.</p>
        </div>
    );
};

export default SponsorsMentors;